import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8e6930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav-left" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "nav-right" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navData, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["nav-item", _ctx.activeCode===item.code?'nav-active':'']),
          onClick: ($event: any) => (_ctx.checkNav(item,index)),
          key: 'nav'+index
        }, [
          (_ctx.activeCode===item.code)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.activeImg,
                alt: ""
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item.img,
                alt: ""
              }, null, 8, _hoisted_5))
        ], 10, _hoisted_3)), [
          [_vShow, index<3 && item.noShow]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navData, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["nav-item", _ctx.activeCode===item.code?'nav-active':'']),
          onClick: ($event: any) => (_ctx.checkNav(item,index)),
          key: 'nav'+index
        }, [
          (_ctx.activeCode===item.code)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.activeImg,
                alt: ""
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item.img,
                alt: ""
              }, null, 8, _hoisted_9))
        ], 10, _hoisted_7)), [
          [_vShow, index>=3 && item.noShow]
        ])
      }), 128))
    ])
  ]))
}